import { Action, Dispatch } from 'redux'
import { closeSubHeaderAction } from 'reducks/nav/actions'

const closeSubHeader = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(closeSubHeaderAction())
  }
}

export default closeSubHeader
